import MisDiscountCodeSliceType from './MisDiscountCodeSliceType';

const MisDiscountCodeInitialState: MisDiscountCodeSliceType = {
  inquiryDiscountCodeResult: {
    loading: false,
    isSuccess: false,
    data: {},
  },
};

export default MisDiscountCodeInitialState;
